<template>
    <DialogFilterCustomers v-model="localShowFilterDialog" :title="$t('clients.clients')" @cancel="handleCancel"
        @update:filteredclients="handleConfirm" ref="dialogFilterclients" />

    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="ClientsList">

        <template v-slot:[SlotsFilters.Filter0]="{ index }">
            <ColumnFilter :title="$t('clients.userName')" :Filter="FieldUserName" :getList="ClientsList"
                @cancel="FieldUserName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="FieldUserName" id="FieldUserName" variant="outlined" maxlength="33"
                        hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('clients.typeOfBusiness')" :Filter="FieldTypeOfBusiness" :getList="ClientsList"
                @cancel="FieldTypeOfBusiness = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="FieldTypeOfBusiness" id="FieldTypeOfBusiness" variant="outlined"
                        maxlength="33" hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter2]>
            <ColumnFilter :title="$t('clients.address')" :Filter="FieldAddress" :getList="ClientsList"
                @cancel="FieldAddress = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldAddress" id="FieldAddress" variant="outlined" maxlength="33"
                        hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter3]>
            <ColumnFilter :title="$t('clients.companyName')" :Filter="FieldCompanyName" :getList="ClientsList"
                @cancel="FieldCompanyName = null">
                <template v-slot:input>
                    <v-text-field v-model="FieldCompanyName" id="FieldCompanyName" variant="outlined" maxlength="33"
                        hide-details>
                    </v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter4]>
            <ColumnFilter :title="$t('clients.status')" :Filter="FieldStatus" :getList="ClientsList"
                @cancel="FieldStatus = []">
                <template v-slot:input>
                    <div class="d-flex flex-column" >
                        <v-checkbox v-for="(label, index) in statusLabels" :key="index" v-model="FieldStatus"
                            :label="label" :value="index" class="mb-0" hide-details/>
                    </div>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter5]>
            <ColumnFilter :title="$t('clients.creationDate')" :Filter="FieldCreatedDate" :getList="ClientsList"
                @cancel="FieldCreatedDate = null">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="FieldCreatedDate" :min-date="new Date('2000-01-01')" :max-date="new Date()"
                            :model-value="FieldCreatedDate" range-enabled
                            @update:model-value="handleDateRangeCreationDate" />
                    </span>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.firstName }} {{ item.lastName }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ item.typeActivity }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">
            {{ item.city + ', ' + item.state }}
        </template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.nomSocial }}</template>
        <template v-slot:[SlotsItems.item4]="{ item }">
            <StatusButton v-if="item" disableIcon :title="statut(item)" :color="getStatusColor(item.accountStatus)">
                <template v-slot:icon>

                    <svg v-if="item.accountStatus == 0" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M18.6695 2H16.7695C14.5895 2 13.4395 3.15 13.4395 5.33V7.23C13.4395 9.41 14.5895 10.56 16.7695 10.56H18.6695C20.8495 10.56 21.9995 9.41 21.9995 7.23V5.33C21.9995 3.15 20.8495 2 18.6695 2Z"
                            fill="#FFFFFF" />
                        <path opacity="0.4"
                            d="M7.24 13.4302H5.34C3.15 13.4302 2 14.5802 2 16.7602V18.6602C2 20.8502 3.15 22.0002 5.33 22.0002H7.23C9.41 22.0002 10.56 20.8502 10.56 18.6702V16.7702C10.57 14.5802 9.42 13.4302 7.24 13.4302Z"
                            fill="#FFFFFF" />
                        <path
                            d="M6.29 10.58C8.6593 10.58 10.58 8.6593 10.58 6.29C10.58 3.9207 8.6593 2 6.29 2C3.9207 2 2 3.9207 2 6.29C2 8.6593 3.9207 10.58 6.29 10.58Z"
                            fill="#FFFFFF" />
                        <path
                            d="M17.7099 21.9999C20.0792 21.9999 21.9999 20.0792 21.9999 17.7099C21.9999 15.3406 20.0792 13.4199 17.7099 13.4199C15.3406 13.4199 13.4199 15.3406 13.4199 17.7099C13.4199 20.0792 15.3406 21.9999 17.7099 21.9999Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="item.accountStatus == 1 || item.accountStatus == 2" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M12.0001 21.9999C16.7884 21.9999 20.6701 18.1182 20.6701 13.3299C20.6701 8.5416 16.7884 4.65991 12.0001 4.65991C7.21177 4.65991 3.33008 8.5416 3.33008 13.3299C3.33008 18.1182 7.21177 21.9999 12.0001 21.9999Z"
                            fill="#FFFFFF" />
                        <path
                            d="M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z"
                            fill="#FFFFFF" />
                        <path
                            d="M14.8906 3.45H9.11062C8.71062 3.45 8.39062 3.13 8.39062 2.73C8.39062 2.33 8.71062 2 9.11062 2H14.8906C15.2906 2 15.6106 2.32 15.6106 2.72C15.6106 3.12 15.2906 3.45 14.8906 3.45Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="item.accountStatus == 3" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.4"
                            d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z"
                            fill="#FFFFFF" />
                        <path
                            d="M10.5795 15.5801C10.3795 15.5801 10.1895 15.5001 10.0495 15.3601L7.21945 12.5301C6.92945 12.2401 6.92945 11.7601 7.21945 11.4701C7.50945 11.1801 7.98945 11.1801 8.27945 11.4701L10.5795 13.7701L15.7195 8.6301C16.0095 8.3401 16.4895 8.3401 16.7795 8.6301C17.0695 8.9201 17.0695 9.4001 16.7795 9.6901L11.1095 15.3601C10.9695 15.5001 10.7795 15.5801 10.5795 15.5801Z"
                            fill="#FFFFFF" />
                    </svg>
                    <svg v-else-if="item.accountStatus == 4" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM10.3198 9.725C10.5373 9.9425 10.5373 10.3025 10.3198 10.52C10.2073 10.6325 10.0648 10.685 9.9223 10.685C9.7798 10.685 9.6373 10.6325 9.5248 10.52L7.7998 8.795L6.0748 10.52C5.9623 10.6325 5.8198 10.685 5.6773 10.685C5.5348 10.685 5.3923 10.6325 5.2798 10.52C5.0623 10.3025 5.0623 9.9425 5.2798 9.725L7.0048 8L5.2798 6.275C5.0623 6.0575 5.0623 5.6975 5.2798 5.48C5.4973 5.2625 5.8573 5.2625 6.0748 5.48L7.7998 7.205L9.5248 5.48C9.7423 5.2625 10.1023 5.2625 10.3198 5.48C10.5373 5.6975 10.5373 6.0575 10.3198 6.275L8.59481 8L10.3198 9.725Z"
                            fill="white" />
                    </svg>
                </template>
            </StatusButton>
        </template>
        <template v-slot:[SlotsItems.item5]="{ item }">{{ item.created.split('T')[0] }}
            {{ item.created.split('T')[1].split('.')[0] }}</template>
        <template v-slot:edit="{ item, index }">
            <ClientItemMenu :Id="index" :is-validated="(!filterMenuitems.includes(item.accountStatus))"
                :is-restricted="(item.accountStatus == 3)" :ClientId="item.idCustomer"
                :GetClientsAfterDeleted="ClientsList" :status="1" /><!-- :status="item.isactive" -->
        </template>
    </gridComponent>
</template>
<script>
import { getCustomers } from '@/api/index';
import StatusButton from '@/genericComponent/StatusButton.vue';
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import DateField from '@/genericComponent/date-field.vue';
import ClientItemMenu from './ClientItemMenu.vue';
import DialogFilterCustomers from './dialogFilterCustomers.vue';

export default {
    components: { StatusButton, GridComponent, ColumnFilter, DateField, ClientItemMenu, DialogFilterCustomers },
    props: {
        showFilterDialog: Boolean,
    },
    mounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.ClientsList();
        });
        this.dialogFilterclientsRef = this.$refs.dialogFilterclients;
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            CompanyList: [],
            search: null,
            filterMenuitems: [1, 3, 4],
            FieldUserName: null,
            FieldTypeOfBusiness: null,
            FieldAddress: null,
            FieldCompanyName: null,
            FieldStatus: [],
            FieldCreatedDate: null,
            SortedBy: null,
            SortingType: null,
            localShowFilterDialog: this.showFilterDialog,
            dialogFilterclientsRef: null,
        }
    },
    methods: {
        handleNullableFilters() {
            this.FieldUserName = null;
            this.FieldTypeOfBusiness = null;
            this.FieldAddress = null;
            this.FieldCompanyName = null;
            this.FieldStatus = [];
            this.FieldCreatedDate = null;
            this.$refs.dialogFilterclients.cleardialogfilter();
            this.ClientsList(1);
        },
        handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.FieldCreatedDateFrom = value[0];
                this.FieldCreatedDateTo = value[1];
            } else {
                this.FieldCreatedDateFrom = null;
                this.FieldCreatedDateTo = null;
            }
        },
        removeClient(selectedItem) {
            this.FieldSupplier.filter(i => i != selectedItem);
        },
        ClientsList: function (page) {
            if (page) { this.page = page }
            getCustomers(this.page, this.PageSize, this.FieldUserName, this.FieldTypeOfBusiness, this.FieldAddress, this.FieldCompanyName, this.FieldStatus, this.FieldCreatedDateFrom, this.FieldCreatedDateTo, this.SortedBy, this.SortingType, this.search).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        getStatusColor(status) {
            switch (status) {
                case 0: return 'blue';   // Created
                case 1: return 'yellow'; // To Correct
                case 2: return 'orange'; // To be validated by admin
                case 3: return 'green';  // Validated Customer
                case 4: return 'red';    // Rejected
                default: return 'gray';   // Default color
            }
        },
        handleCancel() {
            this.localShowFilterDialog = false;
        },
        handleConfirm(UserName, TypeOfBusiness, Address, CompanyName, CreatedFrom, CreatedTo, AccountStatus) {
            this.FieldUserName = UserName;
            this.FieldTypeOfBusiness = TypeOfBusiness;
            this.FieldAddress = Address;
            this.FieldCompanyName = CompanyName;
            this.FieldCreatedDateFrom = CreatedFrom;
            this.FieldCreatedDateTo = CreatedTo;
            this.FieldStatus = AccountStatus;
            this.ClientsList();
            this.localShowFilterDialog = false;
        },
    },
    watch: {
        showFilterDialog(value) {
            this.localShowFilterDialog = value;
        },
    },
    computed: {
        statut() {
            return item => {
                switch (item.accountStatus) {
                    case 0: return this.$t('clients.statusList.created');
                    case 1: return this.$t('clients.statusList.toCorrect');
                    case 2: return this.$t('clients.statusList.toBeValidatedByAdmin');
                    case 3: return this.$t('clients.statusList.validatedCustomer');
                    case 4: return this.$t('clients.statusList.rejected');
                    default: return this.$t('clients.statusList.created');
                }
            };
        },
        headers() {
            const headers = [
                this.$t('clients.userName'),
                this.$t('clients.typeOfBusiness'),
                this.$t('clients.address'),
                this.$t('clients.companyName'),
                this.$t('clients.status'),
                this.$t('clients.creationDate'),
            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
                item5: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
                Filter5: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['16%', '15%', '15%', '15%', '15%', '15%', '5%'];
            return headers;
        },
        isToValidateByAdmin() {
            return this.$t('clients.statusList.toBeValidatedByAdmin');
        },
        isToCorrect() {
            return this.$t('clients.statusList.toCorrect');
        },
        isRejected() {
            return this.$t('clients.statusList.rejected');
        },
        isCreated() {
            return this.$t('clients.statusList.created');
        },
        isValidatedCustomer() {
            return this.$t('clients.statusList.validatedCustomer');
        },
        statusLabels() {
            return [
                this.isCreated,
                this.isToCorrect,
                this.isToValidateByAdmin,
                this.isValidatedCustomer,
                this.isRejected
            ]
        }
    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
